'use strict';

var CookieStorage = require('./shim');

module.exports = function () {
  var defaultStorage = window.sessionStorage;

  // This is a simplistic way to check if storage class
  // is available and works w/o errors.
  try {
    defaultStorage.setItem('check', 'true');
    defaultStorage.removeItem('check');
    return defaultStorage;
  } catch (err) {
    // Fallback to cookie storage.
    return new CookieStorage();
  }
};